import { ReactComponent as AccessMonitorLogo } from '~/assets/smarpanel/accessmonitor-logo.svg';
import { ReactComponent as MozillaLogo } from '~/assets/smarpanel/mozilla.svg';
import { ReactComponent as SecurityHeadersLogo } from '~/assets/smarpanel/securityheaders.svg';
import { SMARPANEL_ACCESSMONITOR_HOME_URL } from './smarPanelAccessMonitor';

export const SMARPANEL_MOZILLA_OBSERVATORY_URL =
  'https://observatory.mozilla.org/';

export const SMARPANEL_SECURITY_HEADERS_URL = 'https://securityheaders.com/';

export const SMARPANEL_TOOLS = [
  {
    id: 'accessmonitor',
    name: 'AccessMonitor',
    linkLabel: 'Site',
    url: SMARPANEL_ACCESSMONITOR_HOME_URL,
    Logo: AccessMonitorLogo,
    summary:
      'Validador oficial de acessibilidade web (WCAG 2.1), desenvolvido pela ARTE em parceria com a FCUL. Avalia páginas com testes ACT Rules certificados pelo W3C e atribui nota de 0 a 10, apoiando a conformidade com o DL n.º 83/2018 e a Declaração de Acessibilidade.',
  },
  {
    id: 'mozilla-observatory',
    name: 'Mozilla Observatory',
    linkLabel: 'Site',
    url: SMARPANEL_MOZILLA_OBSERVATORY_URL,
    Logo: MozillaLogo,
    summary:
      'Ferramenta da Mozilla que analisa cabeçalhos HTTP e configurações de segurança do site. Gera nota e recomendações práticas para reduzir vulnerabilidades comuns e reforçar a postura de segurança da aplicação.',
  },
  {
    id: 'security-headers',
    name: 'Security Headers',
    linkLabel: 'Site',
    url: SMARPANEL_SECURITY_HEADERS_URL,
    Logo: SecurityHeadersLogo,
    summary:
      'Scanner gratuito que verifica os cabeçalhos de segurança HTTP (CSP, HSTS, X-Frame-Options, entre outros). Atribui nota de A+ a F e indica o que está ausente ou mal configurado para mitigar XSS, clickjacking e outros ataques.',
  },
];
